import _objectSpread from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { deactivateAudioGraph } from '../helpers/deactivate-audio-graph';
import { testPromiseSupport } from '../helpers/test-promise-support';
var DEFAULT_OPTIONS = {
  numberOfChannels: 1
};
export var createMinimalOfflineAudioContextConstructor = function createMinimalOfflineAudioContextConstructor(cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, minimalBaseAudioContextConstructor, _startRendering) {
  return /*#__PURE__*/function (_minimalBaseAudioCont) {
    _inherits(MinimalOfflineAudioContext, _minimalBaseAudioCont);
    function MinimalOfflineAudioContext(options) {
      var _this;
      _classCallCheck(this, MinimalOfflineAudioContext);
      var _DEFAULT_OPTIONS$opti = _objectSpread({}, DEFAULT_OPTIONS, options),
        length = _DEFAULT_OPTIONS$opti.length,
        numberOfChannels = _DEFAULT_OPTIONS$opti.numberOfChannels,
        sampleRate = _DEFAULT_OPTIONS$opti.sampleRate;
      var nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
      // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
      if (!cacheTestResult(testPromiseSupport, function () {
        return testPromiseSupport(nativeOfflineAudioContext);
      })) {
        nativeOfflineAudioContext.addEventListener('statechange', function () {
          var i = 0;
          var delayStateChangeEvent = function delayStateChangeEvent(event) {
            if (_this._state === 'running') {
              if (i > 0) {
                nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                event.stopImmediatePropagation();
                _this._waitForThePromiseToSettle(event);
              } else {
                i += 1;
              }
            }
          };
          return delayStateChangeEvent;
        }());
      }
      _this = _possibleConstructorReturn(this, _getPrototypeOf(MinimalOfflineAudioContext).call(this, nativeOfflineAudioContext, numberOfChannels));
      _this._length = length;
      _this._nativeOfflineAudioContext = nativeOfflineAudioContext;
      _this._state = null;
      return _this;
    }
    _createClass(MinimalOfflineAudioContext, [{
      key: "startRendering",
      value: function startRendering() {
        var _this2 = this;
        /*
         * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
         * the state of the nativeOfflineAudioContext might no transition to running immediately.
         */
        if (this._state === 'running') {
          return Promise.reject(createInvalidStateError());
        }
        this._state = 'running';
        return _startRendering(this.destination, this._nativeOfflineAudioContext).finally(function () {
          _this2._state = null;
          deactivateAudioGraph(_this2);
        });
      }
    }, {
      key: "_waitForThePromiseToSettle",
      value: function _waitForThePromiseToSettle(event) {
        var _this3 = this;
        if (this._state === null) {
          this._nativeOfflineAudioContext.dispatchEvent(event);
        } else {
          setTimeout(function () {
            return _this3._waitForThePromiseToSettle(event);
          });
        }
      }
    }, {
      key: "length",
      get: function get() {
        // Bug #17: Safari does not yet expose the length.
        if (this._nativeOfflineAudioContext.length === undefined) {
          return this._length;
        }
        return this._nativeOfflineAudioContext.length;
      }
    }, {
      key: "state",
      get: function get() {
        return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
      }
    }]);
    return MinimalOfflineAudioContext;
  }(minimalBaseAudioContextConstructor);
};